// Vendor imports
const Immutable = require('immutable')
// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')
const ArticleModelRecord = require('client-v2/common/models/article/record')
const { keyedReviver } = require('client-v2/common/state/record-reviver')

class ContentAddModalRecord extends Immutable.Record({
  article: null,
  articleState: FetchStateEnum.EMPTY,
  isSubmitPending: Boolean(),
  isUrlInvalid: Boolean(),
  isVisible: Boolean(),
  url: String()
}) {

  setArticle(articleObj) {
    if (!articleObj) {
      return this.delete('article')
    }
    return this.set('article', Immutable.fromJS(articleObj, articleReviver))
  }
}

const articleReviver = ArticleModelRecord.reviver

ContentAddModalRecord.reviver = keyedReviver(ContentAddModalRecord, {
  article: articleReviver
})

module.exports = ContentAddModalRecord
